
import successInCircleIcon from './success-in-circle.svg'
export default {
  name: 'RequestSuccessModal',
  data() {
    return {
      successInCircleIcon,
      dialog: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    closeBtnClickHandler() {
      this.close()
    },
    close() {
      this.dialog = false
    },
  },
}
